module.exports = "<div #gmap class=\"mapview\">\n</div>\n"